import { FgBlockType } from '../../block-type.js';
import { FgType } from '../../types.js';
import { getDataValue, setDataValue } from '../../runtime.js';
import { sockOut, sockIn } from '../../sockets.js';
import { fgDegToRad } from '../../fg-math.js';

const degToRadDef = {
  type: FgBlockType.DegToRad,
  build: () => ({
    dataIn: [sockIn("a", FgType.Any)],
    dataOut: [sockOut("value", FgType.Any)]
  }),
  updateOutputs(block, ctx, env) {
    const a = getDataValue(ctx, env, block, "a");
    setDataValue(ctx, block, "value", fgDegToRad(a));
  }
};

export { degToRadDef };
//# sourceMappingURL=deg-to-rad.js.map
